export default "__VITE_ASSET__315a9d08__"